import React, { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { authApi } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const run = async () => {
      const hash = window.location.hash || location.hash || "";
      const match = hash.match(/session_id=([^&]+)/);
      const sessionId = match ? decodeURIComponent(match[1]) : null;
      if (!sessionId) {
        navigate("/login", { replace: true });
        return;
      }
      try {
        const user = await authApi.exchange(sessionId);
        setUser(user);
        // clean URL
        window.history.replaceState(null, "", "/admin");
        navigate("/admin", { replace: true, state: { user } });
      } catch (e) {
        navigate("/login", { replace: true, state: { error: "Login mislukt" } });
      }
    };
    run();
  }, [navigate, location, setUser]);

  return (
    <div className="min-h-screen bg-[#1a1a1a] flex items-center justify-center text-[#c5a76f]">
      <div className="flex items-center gap-3">
        <div className="w-3 h-3 rounded-full bg-[#c5a76f] animate-pulse" />
        <div className="w-3 h-3 rounded-full bg-[#c5a76f] animate-pulse" style={{ animationDelay: "150ms" }} />
        <div className="w-3 h-3 rounded-full bg-[#c5a76f] animate-pulse" style={{ animationDelay: "300ms" }} />
        <span className="ml-3 text-sm tracking-widest">AANMELDEN...</span>
      </div>
    </div>
  );
}
